/* eslint-disable jsx-a11y/anchor-is-valid */
import { IonPage } from '@ionic/react';
import React from 'react';
import { useGetUserBlocksQuery } from '../api/BlockApi';
import { BlockListUser } from '../components/BlockListUser';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { IconClose } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
export const BlockedPage: React.FC<{ onDismiss: () => {} }> = ({ onDismiss }) => {
	const { data: blocks } = useGetUserBlocksQuery();
	return (
		<>
			<IonPage>
				<>
					<Header
						title="Hidden Users"
						left={<IconButton icon={<IconClose />} onClick={() => onDismiss()} />}
					/>
					<QuirkIonContent>
						<>
							{blocks &&
								blocks.length > 0 &&
								blocks.map((block, i) => {
									return (
										<div key={'blockUser' + i}>
											<BlockListUser block={block} />
										</div>
									);
								})}
						</>
					</QuirkIonContent>
				</>
			</IonPage>
		</>
	);
};
